<template>
  <!-- Steve's in-app trial prompt on User Management (28 Sep 2026): the
       Leadership Plus card. Renders nothing unless a Direct trial company admin
       (same gate as SetupGuide / the tour). The welcome card, countdown banner
       and IMPROVE Live card that sat above it were removed on 5 Oct 2026
       (Muhammad): the Welcome to IMPROVE wizard is already a trial admin's first
       screen, the header pill carries the countdown and Buy IMPROVE, and IMPROVE
       Live has its own screen. -->
  <div v-if="isTrial" class="trial-prompts">
    <section class="tp-leadership">
      <div class="tp-leadership__copy">
        <h3 class="tp-leadership__title">Develop your managers with Leadership Plus</h3>
        <p class="tp-leadership__body">
          Include Leadership Plus when you purchase IMPROVE or add it later. Relevant modules
          can be uploaded to your platform.
        </p>
      </div>
      <div class="tp-leadership__action">
        <v-btn outlined color="directHeader" :href="leadershipUrl" target="_blank" rel="noopener" style="text-transform: none">
          Explore Leadership Plus
        </v-btn>
      </div>
    </section>
  </div>
</template>

<script>
import { isTrialCompanyAdmin } from '@/utils/onboarding';

export default {
  name: 'TrialPrompts',
  computed: {
    isTrial() {
      return isTrialCompanyAdmin(this.$store.getters);
    },
    leadershipUrl() {
      return 'https://www.improve.online/leadership-plus';
    },
  },
};
</script>

<style scoped>
.trial-prompts {
  max-width: 1180px;
  margin: 0 auto 8px auto;
}
.tp-leadership {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px;
  border-radius: 12px;
  background: #fff;
  border: 1px solid rgba(22, 43, 68, 0.08);
}
.tp-leadership__action {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.tp-leadership__title {
  font-size: 17px;
  font-weight: 700;
  color: #002458;
  margin: 0 0 4px 0;
}
.tp-leadership__body {
  font-size: 14px;
  line-height: 1.5;
  color: #5a6a7a;
  margin: 0;
  max-width: 720px;
}
</style>
